import {
  List,
  Title,
  Datagrid,
  TextField,
  useStore,
  ReferenceField,
  FunctionField,
  ListActions,
  ShowButton,
  DateField,
  EditButton,
  SimpleList,
} from "react-admin";
import CustomFilter from "features/CustomFilter";
import useScheduleFilter from "features/filters/useScheduleFilter";
import { Box, Typography, Paper, useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import SecuredComponent from "server/security/SecuredComponent";
import { studentRequests } from "api/studentApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

export const CYCLIC_STORE_KEY = "cyclicExams.filters";
const ListCyclicExams = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(CYCLIC_STORE_KEY, null);
  const schedule = useScheduleFilter({ filters, hasCourse: true, hasStream: true });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Циклични изпити"} />}
      <CustomFilter
        title="Избери разписание"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={schedule.fields}
        buttonLabel="Покажи"
        buttonDisabled={!schedule.isComplete}
        buttonOnClick={() => handleSearch(schedule.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за циклични изпити .
            </Typography>
          </Box>
        </Paper>
      ) : (
        <List
          title="Циклични изпити"
          actions={
            <SecuredComponent permission={permissions.canManageCyclicExams}>
              <ListActions />
            </SecuredComponent>
          }
          exporter={false}
          filter={filters}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <div>
                  <MobileListRow
                    fields={[
                      {
                        label: "Дисциплина",
                        value: (
                          <ReferenceField
                            source="disciplineId"
                            reference={administrationRequests.getDisciplinesSelect()}
                            sortable={false}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Дата на изпит",
                        value: (
                          <DateField
                            source="examDate"
                            locales="bg-BG"
                            sortable={false}
                          />
                        ),
                      },
                    ]}
                  />
                </div>
              )}
              secondaryText={record => (
                <div>
                  <MobileListRow
                    fields={[
                      {
                        label: "Поток",
                        value: (
                          <ReferenceField
                            source="cyclicStreamId"
                            reference={studentRequests.getCyclicStreamsSelect()}
                            sortable={false}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Начален час на изипит",
                        value: record?.examStartTime ? `${record.examStartTime.substring(0, 5)} ч.` : " - ",
                      },
                      {
                        label: "Краен час на изипит",
                        value: record?.examEndTime ? `${record.examEndTime.substring(0, 5)} ч.` : " - ",
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Зала",
                        value: (
                          <ReferenceField
                            source="roomId"
                            reference={administrationRequests.getRoomsSelect()}
                            sortable={false}
                          >
                            <TextField source="roomName" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  <MobileListRow fields={[{ label: "Учебни групи", value: record?.studyGroups }]} />
                </div>
              )}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canManageCyclicExams}>
                    <EditButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canPreviewCyclicExams}>
                    <ShowButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              rowClick={false}
              bulkActionButtons={false}
            >
              <ReferenceField
                source="cyclicStreamId"
                reference={studentRequests.getCyclicStreamsSelect()}
                label="Поток"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
                label="Дисциплина"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <DateField
                label="Дата на изпит"
                source="examDate"
                locales="bg-BG"
                sortable={false}
              />
              <FunctionField
                sortable={false}
                label="Начален час на изипит"
                render={record => (record?.examStartTime ? `${record?.examStartTime.substring(0, 5)} ч.` : " - ")}
              />
              <FunctionField
                sortable={false}
                label="Краен час на изипит"
                render={record => (record?.examEndTime ? `${record?.examEndTime.substring(0, 5)} ч.` : " - ")}
              />
              <ReferenceField
                sortable={false}
                source="roomId"
                reference={administrationRequests.getRoomsSelect()}
                label="Зала"
              >
                <TextField source="roomName" />
              </ReferenceField>
              <TextField
                source="studyGroups"
                label="Учебни групи"
              />

              <SecuredComponent permission={permissions.canManageCyclicExams}>
                <EditButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewCyclicExams}>
                <ShowButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListCyclicExams;
